import { Checkbox, Menu } from 'semantic-ui-react';
import styled from 'styled-components';

const BrandLogo = styled(Menu.Item)`
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 80%;
  height: 60px;
  margin: auto;
  min-width: 150px;
`;

const LeftSideWrapper = styled(Menu.Menu)`
  display: flex;
  width: 15rem;
  text-align: center;
`;

const RightSideWrapper = styled(Menu.Menu)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledLogoImg = styled.img`
  left: 0;
  width: 50px !important;
  right: 0;
  margin-right: auto;
  height: 50px;
  border-radius: 50% !important;
  background: none;
`;

export const StyledProfileWrapper = styled.div`
  position: relative;
  flex: none;
  height: 2rem;
  width: 2rem;
> span {
  position: absolute;
    height: 100%;
    width: 100%;
    -o-object-fit: contain;
    object-fit: contain;
    border-radius: 9999px;
    background: #f5f5f5;
    > img {
      position: absolute;
      height: 100%;
      width: 100%;
      -o-object-fit: contain;
      object-fit: contain;
      border-radius: 9999px;
      background: #f5f5f5;
    }
`

export const StyledFlag = styled.img<{ $useShadow?: boolean }>`
  width: 25px !important;
  ${props => props.$useShadow && 'filter: drop-shadow(white 0px 1px 2px);'}  
`;

const TopBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TopBarMenu = styled(Menu)`
  background: transparent !important;
  min-height: unset !important;
  border: none !important;
  margin: 0 !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  align-items: center;
  height: 100%;
  display: flex;
`;

const StyledSupportWrapper = styled.div`
width: 300px;
padding: 1em;
`
const StyledTextWrapper = styled.div`
display: flex;
color: white;
align-items: center;
 .text {
  max-width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 3px;
 }
 .icon {
  font-size: 1.5em;
 }
`
const StyledMenuItemText = styled(Menu.Item)`
max-width: 600px;
display: flex;
justify-content: center;
`

const StyledCheckbox = styled(Checkbox)`
display: flex !important;
justify-content: end !important;
margin-top: 20px;
 label {
  font-size: 15px !important;
 }
`

export const El = {
  BrandLogo,
  LeftSideWrapper,
  RightSideWrapper,
  StyledLogoImg,
  TopBarContainer,
  TopBarMenu,
  StyledProfileWrapper,
  StyledSupportWrapper,
  StyledTextWrapper,
  StyledMenuItemText,
  StyledCheckbox
};
